<script setup lang="ts">
import DrugInteractionPatientProfile from "@/drug-interaction/components/DrugInteractionPatientProfile.vue";
import ConsumerProductsHeader from "@/drug-interaction/components/header/ConsumerProductsHeader.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Search} from "@lucide/vue";

defineProps<{
    consumerKey: string;
    customerId: number;
    showVidalAnalysis?: boolean;
}>();

const emits = defineEmits<{
    (e: 'launch-analysis'): void;
    (e: 'trackProducts'): void
}>();
</script>

<template>
  <div class="relative mb-4">
    <div class="flex flex-col md:flex-row justify-between bg-white pt-4 pb-8">
      <DrugInteractionPatientProfile :consumer-key="consumerKey" :customer-id="customerId" />
      <ConsumerProductsHeader :consumer-key="consumerKey" @track-products="emits('trackProducts')" />
    </div>
    <div class="absolute right-4 -bottom-4 flex gap-4">
      <BaseButton v-if="showVidalAnalysis" @click="emits('launch-analysis')">
        <img src="@/assets/images/logos/logo-vidal.png" class="h-4 mr-2" alt="vidal logo">
        <span class="text-primary">Lancer l'analyse</span>
      </BaseButton>
      <BaseButton
        @click="emits('trackProducts')"
      >
        <Search class="mr-2 w-5 h-5" />
        <span class="text-primary"> Controler l'observance</span>
      </BaseButton>
    </div>
  </div>
</template>

<style scoped>

</style>
